import {
    actionTypes as asyncTypes,
    isAsyncOperation,
    isAsyncComplete,
} from "async-ops";
import { ALL } from "../../../reducers/ea-dashboard-reducer";
import { GET_REVIEW_CONTRACTOR_RESPONSE_TIME_SUBMISSIONS } from "../services/get-review-contractor-respone-time-submissions";
export const SET_REVIEW_CONTRACTOR_RESPONSE_TIME_WIDGET_VALUE = "SET_REVIEW_CONTRACTOR_RESPONSE_TIME_WIDGET_VALUE";

const initialState = {
    isLoading: false,
    reviewConractorResponseTimeList: [],
    reviewContractors: []
};

export default function (state = initialState, action) {
    let newState;
    switch (action.type) {
        case SET_REVIEW_CONTRACTOR_RESPONSE_TIME_WIDGET_VALUE:
            newState = { ...state };
            newState = {
                ...newState,
                reviewContractorId: action.data.reviewContractorId,
                timePeriod: action.data.timePeriod,
                toggleValue: action.data.toggleValue
            };
            return newState;
        case asyncTypes.OPERATION:
        case asyncTypes.COMPLETE:
        case asyncTypes.FAILURE:
            if (isAsyncOperation(GET_REVIEW_CONTRACTOR_RESPONSE_TIME_SUBMISSIONS)(action)) {
                return { ...state, reviewConractorResponseTimeList: [],reviewContractors: [] };
            }
            if (isAsyncComplete(GET_REVIEW_CONTRACTOR_RESPONSE_TIME_SUBMISSIONS)(action)) {
                var response = action.response;
                var activeReviewContractor = response?.reviewContractorDto?.length>0 ? response.reviewContractorDto?.filter(x=>x):[];
                activeReviewContractor.unshift(ALL);
                return { ...state, reviewConractorResponseTimeList: response.totalFilesSubmitted,reviewContractors: activeReviewContractor };
            }
            return state;
        default:
            return state;
    }
}